import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./ShareModal.css";

const ShareModal = ({ show, onHide, url, title }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const encUrl = encodeURIComponent(url);
  const encTitle = encodeURIComponent(title);
  const encText = encodeURIComponent(`Check out this guide: ${title}`);

  const channels = [
    {
      key: "whatsapp",
      label: "WhatsApp",
      href: `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`,
      cls: "sh-btn-whatsapp",
      blank: true,
    },
    {
      key: "email",
      label: "Email",
      href: `mailto:?subject=${encTitle}&body=${encodeURIComponent(`${title}\n\n${url}`)}`,
      cls: "sh-btn-email",
      blank: false,
    },
    {
      key: "twitter",
      label: "X / Twitter",
      href: `https://twitter.com/intent/tweet?text=${encText}&url=${encUrl}`,
      cls: "sh-btn-twitter",
      blank: true,
    },
    {
      key: "facebook",
      label: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`,
      cls: "sh-btn-facebook",
      blank: true,
    },
  ];

  return (
    <div className="modal">
      <Modal
        show={show}
        animation={false}
        dialogClassName="sh-dialog"
        aria-labelledby="sh-title"
        centered
        onHide={onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="sh-shell">

            {/* ── Header ── */}
            <div className="sh-header">
              <div className="sh-header-icon">
                <FontAwesomeIcon icon={solid("share-nodes")} />
              </div>
              <h2 className="sh-title" id="sh-title">Share Guide</h2>
              <button className="sh-close" onClick={onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            {/* ── Body ── */}
            <div className="sh-body">

              {/* Copy link */}
              <div className="sh-section">
                <span className="sh-label">Guide Link</span>
                <div className="sh-copy-row">
                  <input
                    className="sh-url-input"
                    value={url}
                    readOnly
                    onClick={(e) => e.target.select()}
                  />
                  <button
                    className={`sh-copy-btn${copied ? " sh-copy-btn--done" : ""}`}
                    onClick={handleCopy}
                  >
                    <FontAwesomeIcon icon={copied ? solid("check") : solid("copy")} />
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>
              </div>

              {/* Share channels */}
              <div className="sh-section">
                <span className="sh-label">Share via</span>
                <div className="sh-channels">
                  {channels.map((ch) => (
                    <a
                      key={ch.key}
                      className={`sh-channel-btn ${ch.cls}`}
                      href={ch.href}
                      target={ch.blank ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                      onClick={onHide}
                    >
                      {ch.label}
                    </a>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ShareModal;
